import type { Route } from 'nextjs-routes';

export enum PromotionId {
  FEEDBACK_INTERVIEW = 'feedback-interview',
}

export type PromotionEnabledType = boolean | { type: 'wallet-allowlist' };

export type Promotion = {
  id: PromotionId;
  storageKey: string;
  enabled: PromotionEnabledType;
  image: { alt: string; src: string };
  title: string;
  description: string;
  cta: { href: Route | string; label: string };
};

export const PROMOTIONS: Promotion[] = [
  {
    id: PromotionId.FEEDBACK_INTERVIEW,
    storageKey: 'matcha-promo-feedback-interview-10-07-2026',
    enabled: { type: 'wallet-allowlist' },
    image: {
      alt: '50 USDC reward',
      src: '/images/promo-carousel/feedback-interview-50-usdc.png',
    },
    title: 'Earn $50',
    description: 'Schedule a call with the Matcha team and earn 50 USDC.',
    cta: {
      href: 'https://calendly.com/d/cx84-9fc-sx4/matcha-feedback-interviews',
      label: 'Schedule call',
    },
  },
];
